
import { getAnioDefault } from '../utils/getAnioDefault';

export class ArcFiltros {
    tipoClasificador: string = "";
    tipoValor: string = "";
    idTipoValor: string = "";
    idVariable: string = "";
    codigo: string = "";
    indicador: string = "";
    sector: string = "";
    entidad: string = "";
    anio: string = getAnioDefault();
    desagregacionPoblacional: string = "";
    codigoDivipolaDpto: string = "";
    codigoDivipolaMpio: string = "";
    codigoDivipolaPdetRegion: string = "";
    codigoDivipolaPdetMunicipio: string = "";
    unidadMedida: string = "";
    esPDET: string = "";
    internos: string = "";
    primerainfancia: string = "";
    sentenciaT302: string = "";
    tiposClasificadores: string = "";
    anios: string = "";
}

export const DEFAULT_FILTER: ArcFiltros = {    
    tipoClasificador: "",
    tipoValor: "",
    idTipoValor: "",
    idVariable: "",
    codigo: "",
    indicador: "",
    sector: "",
    entidad: "",
    anio: getAnioDefault(),    
    desagregacionPoblacional: "",
    codigoDivipolaDpto: "",
    codigoDivipolaMpio: "",
    codigoDivipolaPdetRegion: "",
    codigoDivipolaPdetMunicipio: "",
    unidadMedida: "",    
    esPDET: "",
    internos : "",
    primerainfancia: "",
    sentenciaT302: "",
    tiposClasificadores: "",
    anios: "",
};